import Vue from "vue"
import Router from 'vue-router'
import  { routers }  from './route'

Vue.use(Router)

const routerConfig = {
	mode:'hash',
	routes: routers
}

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router = new Router(routerConfig)

export default router
